<template lang="pug">
  section.b-section
    Link._back(v-if="back" :to="back")
      Icon(name="arr-back")
      | {{ back.title }}
    ._title-wrap(:class="{ 'with-button': !!$slots.button }")
      h1._title(:class="{ crossed }") {{ title }}
        slot(name="title")
      slot(name="button")
    slot
</template>

<script>
export default {
  name: 'CommonSection',
  props: {
    title: {
      type: String,
      required: true,
    },
    back: Object,
    crossed: Boolean,
  },
};
</script>

<style scoped lang="scss">

.section {
  &__title {
    font-weight: 700;
    color: var(--color-dark-gray);
    font-size: 40px;
    display: flex;
    align-items: center;
    gap: 30px;

    &.crossed {
      text-decoration: underline;
      text-underline-offset: -.35em;
      text-decoration-skip-ink: none;
      text-decoration-thickness: 4px;
    }
  }

  &__title-wrap {
    padding: 73px 0 63px;

    &.with-button {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 30px;
    }
  }

  &__back {
    padding: 20px 0;
    font-size: 12px;
    line-height: 24px;
    color: #788CA1;
    display: inline-flex;
    align-items: center;
    gap: 5px;
  }

  &__back + &__title-wrap {
    padding: 15px 0 35px;
  }

  @media (max-width: 768px) {
    &__title {
      text-align: center;
    }

    &__title-wrap {
      padding: 50px 0;
    }

    &__back + &__title-wrap &__title {
      text-align: left;
    }
  }

  @media (max-width: 768px) {
    &__title-wrap.with-button {
      gap: 10px;
      flex-direction: column;
    }

    &__title {
      flex-direction: column;
      gap: 10px;
      align-items: center;
    }
  }
}

</style>
